import { PushNotificationBanner } from "../components/push-notification-banner";
import { richTextRenderer } from "../utils/rich-text-renderer";

const test = ({ __typename }: { __typename: string }): boolean =>
  __typename === "VinoData_PushNotificationBanner";

const create = (data: any): JSX.Element => {
  return data ? (
    <PushNotificationBanner
      title={data.title}
      message={richTextRenderer(
        { json: data.message },
        {
          p: { color: "inherit", fontSize: [1, 2] },
          b: { color: "inherit" },
        }
      )}
    />
  ) : null;
};

export default { test, create };
